import Login from './login-register'
import Loading from './LeonLoading'
import NoNetwork from './NoNetwork'
import Alter from './leonAlter'
import LeonDialog from './LeonDialog'
import IntegralMask from './IntegralMask'
import BattleDialog from './BattleDialog'
import SQDialog from './SQDialog'
import ProctorBattleDialog from './proctorBattleDialog'
import ProctorSQDialog from './proctorSQDialog'
import DefaultDialog from './defaultDialog'

const install = Vue => {
  Vue.component(Login.name, Login) // 登录弹框
  Vue.component(LeonDialog.name, LeonDialog) // 遮罩层
  Vue.component(IntegralMask.name, IntegralMask) // 积分

  Vue.prototype.$_Login = Login.install // 登录弹框
  Vue.prototype.$_Loading = Loading.install // 加载层
  Vue.prototype.$_NoNetwork = NoNetwork.install // 断网弹框
  Vue.prototype.$_Alter = Alter.install // alter弹框
  Vue.prototype.$_IntegralMask = IntegralMask.install // 积分弹框
  Vue.prototype.$_BattleDialog = BattleDialog.install // 对战弹框
  Vue.prototype.$_SQDialog = SQDialog.install // SQ弹框
  Vue.prototype.$_ProctorBattleDialog = ProctorBattleDialog.install // 监考弹框
  Vue.prototype.$_ProctorSQDialog = ProctorSQDialog.install
  Vue.prototype.$_DefaultDialog = DefaultDialog.install // 默认弹框
}
export default install



// WEBPACK FOOTER //
// ./src/plugin/index.js